<template>
    <el-dialog title="预约管理" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <!--添加时段-->
        <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加时段</el-button></div>
        <el-form size="small" :model="form1" ref="form">
            <el-table :data="form1.subscribe" border  style="width: 100%">
                <el-table-column label="序号" width="100px">
                    <template slot-scope="scope">
                        <el-form-item :prop="'subscribe.'+ scope.$index + '.sort'" :rules="[{ required: true, message: ' ' }]">
                            <el-input type="number" v-model="scope.row.sort" autocomplete="off"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="时间范围">
                    <template slot-scope="scope">
                        <el-form-item label="起始" :prop="'subscribe.'+ scope.$index + '.start_time'" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]">
                            <el-time-select
                                placeholder="起始时间"
                                v-model="scope.row.start_time"
                                :picker-options="{
                                start: '00:00',
                                step: '00:30',
                                end: '24:00'
                                }">
                            </el-time-select>
                        </el-form-item>
                        <el-form-item label="结束" :prop="'subscribe.'+ scope.$index + '.end_time'" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]">
                            <el-time-select
                                placeholder="结束时间"
                                v-model="scope.row.end_time"
                                :picker-options="{
                                start: '00:00',
                                step: '00:30',
                                end: '24:00',
                                minTime: scope.row.start_time
                                }">
                            </el-time-select>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="服务人数" width="250px">
                    <template slot-scope="scope">
                        <el-form-item label="服务人数" :prop="'subscribe.'+ scope.$index + '.number'" :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]">
                            <el-input type="number" v-model="scope.row.number" autocomplete="off"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="80px">
                    <template slot-scope="scope">
                        <el-button @click="delClick(scope.$index)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import StoreApi from '@/api/store.js';
    import {deepClone} from '@/utils/base.js';
    export default {
        data() {
            return {
                /*左边长度*/
                formLabelWidth: '80px',
                /*是否显示*/
                dialogVisible: false,
                loading: false,
                form1: {},
            };
        },
        props: ['open_edit', 'form'],
        created() {
            this.dialogVisible = this.open_edit;
            this.form1 = deepClone(this.form)
        },
        methods: {
            /*修改分类*/
            editCategory() {
                let self = this;
                let params = {store_id: this.form.store_id,subscribe:this.form1.subscribe};
                
                self.$refs.form.validate((valid) => {
                    if (valid) {
                        self.loading = true;
                        StoreApi.subscribe(params, true)
                        .then(data =>
                        {
                            self.loading = false;
                            self.$message({
                                message: '恭喜你，修改成功',
                                type: 'success'
                            });
                            self.dialogFormVisible(true);

                        })
                        .catch(error =>
                        {
                            self.loading = false;
                        });
                    }
                })
            },
            /**
             * 添加默认数据
             */
            addClick() {
                this.form1.subscribe.push({sort:1,start_time:'',end_time:'',number:1});
            },
            /**
             * 删除时段
             */
            delClick(index) {
                this.form1.subscribe.splice(index,1)
            },

            /*关闭弹窗*/
            dialogFormVisible(e) {
                this.$emit('closeDialog', {
                    openDialog: false
                })
            }

        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/store/store/part/Subscribe.vue